import React, { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ssoExchange } from 'src/features/Auth/Auth.thunks';

const SsoRedirect: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const hasRequestedRef = useRef(false);

  useEffect(() => {
    if (hasRequestedRef.current) {
      return;
    }
    hasRequestedRef.current = true;

    const queryString =
      location.search ||
      window.location.search ||
      (location.hash.includes('?')
        ? location.hash.slice(location.hash.indexOf('?'))
        : '');
    const params = new URLSearchParams(queryString);
    const code = params.get('code');
    const sessionState = params.get('session_state');
    const state = params.get('state');
    if (!code || !sessionState || !state) {
      navigate('/auth/signin', { replace: true });
      return;
    }

    const runCallback = async () => {
      try {
        const callbackParams = {
          code,
          session_state: sessionState,
          state,
        };
        await ssoExchange(callbackParams);
        navigate('/home', { replace: true });
      } catch (err) {
        navigate('/auth/signin', { replace: true });
      }
    };

    runCallback();
  }, [location.search, navigate]);

  return null;
};

export default SsoRedirect;
